module.exports = {"default":{"mailAddress":"mailto:jira@geops.ch"},"jemh":{"deskName":"JEMH Service Desk","announcementConfKey":"8456955","mailAddress":"mailto:trafimage_karten@geops.ch"},"altlast4web":{"deskName":"Altlast4Web Service Desk","announcementConfKey":"17696901","mailAddress":"mailto:altlast_support@geops.ch"},"trafimage":{"deskName":"Trafimage Karten und Bahnhofpläne","announcementConfKey":"1868598","mailAddress":"mailto:sbb_map@geops.ch"}}


//////////////////
// WEBPACK FOOTER
// ./static/conf.json
// module id = 99
// module chunks = 1